export default __webpack_public_path__ + "static/media/logo-card-1440w.5cf7bf81.webp";